import { getAssociatedTokenAddressSync } from "@solana/spl-token";
import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import BN from "bn.js";
import { ReferralProgram, StakingAccount } from "../type";

export interface IStakeParams {
  referralProgram: ReferralProgram;
  stakingAddress: PublicKey;
  stakingAccount: StakingAccount;
  escrowAddress: PublicKey;
  owner: PublicKey;
  amount: BN;
}

export async function createStakeIx(
  params: IStakeParams,
): Promise<TransactionInstruction> {
  const {
    referralProgram,
    stakingAddress,
    stakingAccount,
    escrowAddress,
    owner,
    amount,
  } = params;

  const ownerTokenVault = getAssociatedTokenAddressSync(
    stakingAccount.tokenMint,
    owner,
    true,
  );

  return referralProgram.methods
    .stake({
      amount,
      padding: Array(5).fill(new BN(0)),
    })
    .accountsPartial({
      staking: stakingAddress,
      escrow: escrowAddress,
      tokenVault: stakingAccount.tokenVault,
      tokenMint: stakingAccount.tokenMint,
      ownerTokenVault,
      owner,
    })
    .instruction();
}
